// extracted by mini-css-extract-plugin
export var numpadContainer = "_pr-1";
export var phoneButton = "_pr-0";